var map = {
	"./android-icon-144x144": 79,
	"./android-icon-144x144.png": 79,
	"./android-icon-192x192": 80,
	"./android-icon-192x192.png": 80,
	"./android-icon-36x36": 81,
	"./android-icon-36x36.png": 81,
	"./android-icon-48x48": 82,
	"./android-icon-48x48.png": 82,
	"./android-icon-72x72": 83,
	"./android-icon-72x72.png": 83,
	"./android-icon-96x96": 84,
	"./android-icon-96x96.png": 84,
	"./apple-icon": 85,
	"./apple-icon-114x114": 86,
	"./apple-icon-114x114.png": 86,
	"./apple-icon-120x120": 87,
	"./apple-icon-120x120.png": 87,
	"./apple-icon-144x144": 88,
	"./apple-icon-144x144.png": 88,
	"./apple-icon-152x152": 89,
	"./apple-icon-152x152.png": 89,
	"./apple-icon-180x180": 90,
	"./apple-icon-180x180.png": 90,
	"./apple-icon-57x57": 91,
	"./apple-icon-57x57.png": 91,
	"./apple-icon-60x60": 92,
	"./apple-icon-60x60.png": 92,
	"./apple-icon-72x72": 93,
	"./apple-icon-72x72.png": 93,
	"./apple-icon-76x76": 94,
	"./apple-icon-76x76.png": 94,
	"./apple-icon-precomposed": 95,
	"./apple-icon-precomposed.png": 95,
	"./apple-icon.png": 85,
	"./apple-touch-icon-ipad": 96,
	"./apple-touch-icon-ipad.png": 96,
	"./apple-touch-icon-ipad3": 97,
	"./apple-touch-icon-ipad3.png": 97,
	"./apple-touch-icon-iphone": 98,
	"./apple-touch-icon-iphone.png": 98,
	"./apple-touch-icon-iphone4": 99,
	"./apple-touch-icon-iphone4.png": 99,
	"./favicon-16x16": 100,
	"./favicon-16x16.png": 100,
	"./favicon-32x32": 101,
	"./favicon-32x32.png": 101,
	"./favicon-96x96": 102,
	"./favicon-96x96.png": 102,
	"./favicon.ico": 164,
	"./horizontal-logo-small": 103,
	"./horizontal-logo-small.png": 103,
	"./logo-transparent-lg-dark": 104,
	"./logo-transparent-lg-dark.png": 104,
	"./logo-transparent-sm-bare": 105,
	"./logo-transparent-sm-bare.png": 105,
	"./logo-transparent-sm-dark-bare": 106,
	"./logo-transparent-sm-dark-bare.png": 106,
	"./manifest.json": 165,
	"./ms-icon-144x144": 107,
	"./ms-icon-144x144.png": 107,
	"./ms-icon-150x150": 108,
	"./ms-icon-150x150.png": 108,
	"./ms-icon-310x310": 109,
	"./ms-icon-310x310.png": 109,
	"./ms-icon-70x70": 110,
	"./ms-icon-70x70.png": 110,
	"./naked-logo": 111,
	"./naked-logo.png": 111,
	"./square-logo-small": 112,
	"./square-logo-small.png": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;